module.exports = __webpack_public_path__ + "img/mirror_world_tab.df6ed6b9.png";